import { Injectable } from '@angular/core';
import { QueryEntity } from '@examdojo/state';
import { ReviewSolutionImageStoreModel, ReviewSolutionImageUIModel } from './review-solution-image.model';
import { ReviewSolutionImageState, ReviewSolutionImageStore } from './review-solution-image.store';

@Injectable({ providedIn: 'root' })
export class ReviewSolutionImageQuery extends QueryEntity<
  ReviewSolutionImageState,
  ReviewSolutionImageStoreModel,
  ReviewSolutionImageUIModel,
  'id'
> {
  constructor(protected override store: ReviewSolutionImageStore) {
    super(store);
  }
}
